module.exports = __webpack_public_path__ + "img/benefits-teachers-2.c2e3a66b.svg";